import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import b from 'b_';
import { SimpleCounterStore } from '../../stores/DashboardStore';
import WidgetBase from './WidgetBase';
import './WidgetCounter.css';

const block = b.lock('WidgetCounter');

class WidgetCounter extends Component {
    static propTypes = {
        exact: PropTypes.bool,
        store: SimpleCounterStore.PropType.isRequired,
    };

    render() {
        const { store, exact, ...props } = this.props;
        const formatterValue = exact ? store.formattedValueExact : store.formattedValueCompact;
        return <WidgetBase
            flipStore={store.flip}
            loading={store.updateState.successCount === 0}
            {...props}
        >
            <div
                className={block('Value', { longValue: formatterValue.length > 7 })}
                title={store.formattedValueExact}
            >
                {formatterValue}
            </div>
        </WidgetBase>;
    }
}

export default observer(WidgetCounter);
